import React, { useMemo } from "react";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../store"; // Update with your actual store path

const AppThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const mode = useSelector((state: RootState) => state.themeState.mode);
  // Define Theme
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          background: {
            default: mode === "dark" ? "#111929" : "#ffffff", // Dark/light mode backgrounds
          },
          text: {
            primary: mode === "dark" ? "#E5E7EB" : "#212121", // Light gray for dark mode, dark gray for light mode
          },
        },

        // ADD THIS →
        typography: {
          fontFamily: `"Segoe UI Semilight", "Segoe UI", sans-serif`,
          fontWeightLight: 300,
          fontWeightRegular: 300,
        },

        components: {
          MuiCssBaseline: {
            styleOverrides: `
            body {
              font-family: "Segoe UI Semilight", "Segoe UI", sans-serif;
              font-weight: 300;
            }
          `,
          },
          MuiSvgIcon: {
            styleOverrides: {
              root: {
                color: mode === "dark" ? "#E5E7EB" : "black", // Light blue in dark mode, dark gray in light mode
              },
            },
          },
        },
      }),
    [mode]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />{" "}
      {/* Ensures global styles like background & text colors */}
      {children}
    </ThemeProvider>
  );
};

export default AppThemeProvider;
